import axios from 'axios'
import { request } from '@/utils/request'

export default {
  login ({ username, password }) {
    const formData = { login: username, password }
    return axios.post(import.meta.env.VITE_APP_LOGIN_API + 'login', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      withCredentials: true
    }).then(() => {
      return request({
        url: 'user',
        method: 'get'
      })
    })
  },
  shortLogin () {
    return request({
      url: 'user',
      method: 'get'
    })
  },
  logout () {
    return axios.get(import.meta.env.VITE_APP_LOGIN_API + 'logout', null, {
      withCredentials: true
    })
  },
  saveUserSettings (propsObject) {
    return request({
      url: 'user/setting',
      method: 'post',
      data: propsObject
    })
  }
}
